import userOrganizationsApi from '@/api/user/organizations'
import OrganizationDataService from '@/services/api/OrganizationDataService'

const state = {
    unconnectedOrganizations: [],
    showDialog: false,
    currentOrganization: null,
}

const getters = {
    getCurrentOrganization (state) {
        return state.currentOrganization
    },
}

const actions = {
    async fetchUnconnectedOrganizations ({ state }) {
        try {
            const response = await userOrganizationsApi.fetchUnconnectedOrganizations()

            if (response.items.length) {
                state.unconnectedOrganizations = response.items.slice()
                state.currentOrganization = { ...state.unconnectedOrganizations.shift() }
                state.showDialog = true
            }
        } catch (e) {
            throw new Error(e)
        }
    },
    async fetchOrganization ({ state }, id) {
      try {
        state.currentOrganization = await OrganizationDataService.getOne(id)
        state.showDialog = true
      } catch (e) {
        throw new Error(e)
      }
    },
    async acceptConnectionAgreement ({ state }) {
        if (!state.currentOrganization) {
            throw new Error('Организация не найдена')
        }

        try {
            await userOrganizationsApi.acceptConnectionAgreement(state.currentOrganization.id)
            if (state.unconnectedOrganizations.length) {
                state.currentOrganization = { ...state.unconnectedOrganizations.shift() }
            } else {
                state.showDialog = false
                state.currentOrganization = null
            }
        } catch (e) {
            throw new Error(e)
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
}
